import PolicyLayout, { PolicySection } from "@/components/PolicyLayout";

const LAST_UPDATED = "May 15, 2026";

export default function TermsPage() {
  return (
    <PolicyLayout
      title="Terms & Conditions"
      subtitle="Legal"
      lastUpdated={LAST_UPDATED}
      testId="terms-page"
    >
      <p>
        Welcome to Resurrected Gun Parts ("we," "us," "our," or the "Company"). These Terms & Conditions
        ("Terms") govern your access to and use of <a href="https://resurrectedgunparts.com" className="text-[#C0A062] hover:underline">resurrectedgunparts.com</a> (the
        "Site") and any products or services purchased through it. By using the Site or placing an order, you agree to
        these Terms in full. If you do not agree, please do not use the Site.
      </p>

      <PolicySection title="1. Eligibility">
        <p>
          You must be at least 18 years of age and legally able to enter into a binding contract in the jurisdiction in
          which you reside to purchase from this Site. By placing an order, you represent and warrant that you meet
          these requirements and that any products purchased will be used only in compliance with all applicable
          federal, state, and local laws.
        </p>
      </PolicySection>

      <PolicySection title="2. Products & Compliance">
        <p>
          Resurrected Gun Parts sells reproduction parts and components for vintage military and surplus firearms. Our
          products are sold for restoration, repair, and historical preservation purposes. You are solely responsible
          for ensuring that the purchase, possession, transfer, and use of any product is lawful in your jurisdiction.
        </p>
        <p>
          We sell and ship exclusively within the <strong className="text-white">Continental United States</strong>.
          We do not ship to Alaska, Hawaii, the District of Columbia, U.S. territories, APO/FPO/DPO addresses,
          freight forwarders, or international destinations, and we do not ship to any jurisdiction where the sale,
          possession, or use of a product is prohibited or restricted by federal, state, or local law. We reserve
          the right to cancel and refund any order that would violate applicable law. See our{" "}
          <a href="/shipping-policy" className="text-[#C0A062] hover:underline">Shipping Policy</a> for details.
        </p>
        <p>
          We do not sell complete firearms, receivers, or other items requiring a Federal Firearms License (FFL) to
          transfer. All product descriptions, images, and specifications are provided in good faith but are not
          guaranteed to be free of errors or omissions.
        </p>
      </PolicySection>

      <PolicySection title="3. Orders, Pricing & Payment">
        <p>
          All prices are listed in U.S. Dollars and are subject to change without notice. Placement of an order
          constitutes an offer to purchase, which we may accept or decline at our discretion (including, but not
          limited to, situations involving pricing errors, suspected fraud, inventory issues, or legal restrictions).
          Payment is processed at the time of purchase through our authorized payment processors.
        </p>
      </PolicySection>

      <PolicySection title="4. Shipping, Returns & Refunds">
        <p>
          Shipping and return terms are governed by our separate{" "}
          <a href="/shipping-policy" className="text-[#C0A062] hover:underline">Shipping Policy</a> and{" "}
          <a href="/refund-policy" className="text-[#C0A062] hover:underline">Refund Policy</a>, both of which are
          incorporated into these Terms by reference.
        </p>
      </PolicySection>

      <PolicySection title="5. Intellectual Property">
        <p>
          All content on the Site — including text, graphics, logos, images, product photography, and software — is
          the property of Resurrected Gun Parts or its content suppliers and is protected by U.S. and international
          copyright, trademark, and other intellectual property laws. You may not reproduce, redistribute, or use any
          content from the Site without our prior written consent.
        </p>
      </PolicySection>

      <PolicySection title="6. User Accounts">
        <p>
          When you create an account, you are responsible for maintaining the confidentiality of your login credentials
          and for all activity that occurs under your account. You agree to notify us immediately of any unauthorized
          access. We reserve the right to suspend or terminate accounts at our discretion.
        </p>
      </PolicySection>

      <PolicySection title="7. Disclaimers & Limitation of Liability">
        <p>
          The Site and all products are provided "as is" and "as available" without warranties of any kind, express or
          implied, except as required by law. To the maximum extent permitted by law, Resurrected Gun Parts shall not
          be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits
          or revenues, arising out of or relating to your use of the Site or any product purchased through it.
        </p>
        <p>
          You assume all risk associated with the installation, modification, and use of any product purchased from us.
          Reproduction parts may require fitting, finishing, or professional gunsmithing to function properly. You are
          responsible for verifying compatibility and proper installation.
        </p>
      </PolicySection>

      <PolicySection title="8. Indemnification">
        <p>
          You agree to indemnify, defend, and hold harmless Resurrected Gun Parts and its officers, employees, and
          agents from and against any claims, damages, liabilities, losses, and expenses (including reasonable
          attorneys' fees) arising out of or related to your use of the Site, your violation of these Terms, or your
          violation of any law or rights of any third party.
        </p>
      </PolicySection>

      <PolicySection title="9. Governing Law">
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the State of Arizona, without
          regard to its conflict-of-laws provisions. Any dispute arising under these Terms shall be resolved in the
          state or federal courts located in Arizona, and you consent to the exclusive jurisdiction and venue of such
          courts.
        </p>
      </PolicySection>

      <PolicySection title="10. Changes to These Terms">
        <p>
          We may revise these Terms at any time by posting an updated version on this page. Continued use of the Site
          after a revision constitutes acceptance of the updated Terms. We encourage you to check this page
          periodically.
        </p>
      </PolicySection>

      <PolicySection title="11. Contact">
        <p>
          Resurrected Gun Parts<br />
          Email:{" "}
          <a href="mailto:admin@resurrectedgunparts.com" className="text-[#C0A062] hover:underline">
            admin@resurrectedgunparts.com
          </a>
          <br />
          Phone: (928) 637-8133
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
